import { EnvironmentUrls } from 'Roblox';
import { TPageType } from '../types/bedev1Types';

const { gamesApi } = EnvironmentUrls;

const url = {
  getOmniRecommendations: (
    pageType: TPageType,
    sessionId?: string
  ): { url: string; withCredentials: boolean } => ({
    url: `${gamesApi}/v1/games/omni-recommendations?model.pageType=${pageType}${
      sessionId !== undefined ? `&model.sessionId=${sessionId}` : ''
    }`,
    withCredentials: true
  }),
  getOmniRecommendationsMetadata: {
    url: `${gamesApi}/v1/games/omni-recommendations-metadata`,
    withCredentials: true
  },
  getGameList: { url: `${gamesApi}/v1/games/list`, withCredentials: true }
};

const defaultCacheCriteria = {
  refreshCache: false,
  expirationWindowMS: 30000,
  useCache: true
};

export default {
  url,
  defaultCacheCriteria
};
